import React, { useEffect, useState } from "react";
import { Loader2, Eye, Users, MousePointerClick, Lock, CreditCard } from "lucide-react";
import api from "@/lib/api";
import { Kpi, WindowSelector, DailyChart, SourcesTable, CampaignsTable } from "./statsWidgets";

export default function CuratedStatsTab({ trip }) {
  const [days, setDays] = useState(30);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.get(`/curated-trips/${trip.curated_trip_id}/stats`, { params: { days } })
      .then(({ data }) => { if (alive) setStats(data); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [trip.curated_trip_id, days]);

  if (!stats) return <div className="p-6 text-sm text-clay-600 flex items-center gap-2" data-testid="tab-content-stats"><Loader2 size={14} className="animate-spin"/> Cargando…</div>;

  return (
    <div className="space-y-6" data-testid="tab-content-stats">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="smallcaps">Tráfico de la landing pública</div>
          <p className="text-[12px] text-clay-600 mt-1">
            Visitas reales a <code>/curated/{trip.public_token}</code>. No se cuentan las visitas del equipo con sesión iniciada ni los robots.
            {stats.first_event_at && <> Registrando desde {new Date(stats.first_event_at).toLocaleDateString("es-ES")}.</>}
          </p>
        </div>
        <WindowSelector days={days} onChange={setDays}/>
      </div>

      {stats.views_total === 0 && (
        <div className="border border-dashed border-clay-300 p-8 text-center text-sm text-clay-600" data-testid="stats-empty">
          Todavía no hay visitas registradas. Se empezarán a contar en cuanto alguien abra el enlace público del viaje.
        </div>
      )}

      <div className={`grid grid-cols-2 md:grid-cols-5 gap-3 ${loading ? "opacity-60" : ""}`}>
        <Kpi icon={Eye} label="Visitas" value={stats.views} sub={`${stats.devices.mobile} móvil · ${stats.devices.desktop} escritorio`} testid="kpi-views"/>
        <Kpi icon={Users} label="Visitantes únicos" value={stats.visitors} testid="kpi-visitors"/>
        <Kpi icon={MousePointerClick} label="Clic en Reserve" value={stats.reserve_opens} sub={`${stats.rates.reserve_open}% de las visitas`} testid="kpi-reserve"/>
        <Kpi icon={Lock} label="Plazas retenidas" value={stats.holds} sub={`${stats.rates.hold}% conversión a reserva`} testid="kpi-holds"/>
        <Kpi icon={CreditCard} label="Pagadas" value={stats.paid} sub={`${stats.seats_paid} plazas · ${stats.rates.paid}% de visitas`} testid="kpi-paid"/>
      </div>

      <DailyChart daily={stats.daily}/>
      <div className="grid lg:grid-cols-2 gap-6">
        <SourcesTable sources={stats.sources}/>
        <CampaignsTable campaigns={stats.campaigns}/>
      </div>
    </div>
  );
}
